import { render } from "./HomeOnePage.vue?vue&type=template&id=039824c6"
import script from "./HomeOnePage.vue?vue&type=script&lang=js"
export * from "./HomeOnePage.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__